import { defineSetting } from '../settingsRegistry';
import { figureOutlineTag, registerFigureOutlineSource } from './figureOutlineFlag';

declare module '../settingsRegistry' {
  interface Settings {
    /**
     * Figure outline style (render/figureOutline.ts): 0 = dark ink (the default look), 1 = the scene's style, each
     * outline pixel a darker step of the colour it borders, 2 = none. Players, people, beasts and weapons; fixed per page load.
     */
    figureOutline: number;
  }
}

defineSetting({
  key: 'figureOutline',
  default: 0,
  order: 104,
  menu: {
    group: 'visual',
    label: 'เส้นขอบตัวละคร',
    choices: ['ดำ', 'ตามสีฉาก', 'ไม่มี'],
    note: () =>
      loaded && ['', '-sceneout', '-noout'][loaded.figureOutline] !== figureOutlineTag()
        ? 'ตัวละครจะเปลี่ยนหลังโหลดเกมใหม่'
        : 'ดำ = เส้นขอบสีดำเหมือนเดิม ตามสีฉาก = เส้นขอบเป็นสีเข้มของสีที่มันล้อมอยู่ เหมือนฉาก · ไม่มี = ไม่มีเส้นขอบ',
  },
});

// The saved value, once the settings are loaded (no static import: this file loads while settings.ts is being built).
let loaded: { figureOutline: number } | undefined;
void import('../settings').then((s) => {
  loaded = s.settings;
  registerFigureOutlineSource(() => s.settings.figureOutline);
});
